const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/admin`;

export const getAllUsers = async () => {
  try {
    const response = await fetch(`${BASE_URL}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const users = await response.json();
      return users;
    } else {
      console.error("Error fetching users data.", response.statusText);
      return [];
    }
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};

export const updateUser = async (adminId, userData) => {
  try {
    const response = await fetch(`${BASE_URL}/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${adminId}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
    if (response.ok) {
      return { updated: true };
    } else {
      return { updated: false };
    }
  } catch (error) {
    console.error("Error:", error);
    return { updated: false };
  }
};

export const deleteVideo = async (clerkId, videoId, timestamp) => {
  try {
    const response = await fetch(`${BASE_URL}/videos/`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${clerkId}`,
      },
      body: JSON.stringify({ videoId, timestamp }),
    });
    if (response.ok) {
      return { deleted: true };
    } else {
      return { delete: false };
    }
  } catch (error) {
    console.error("Error:", error);
    return { deleted: false };
  }
};

export const getAllVideos = async () => {
  try {
    const response = await fetch(`${BASE_URL}/videos`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const data = await response.json();
      const tranformedData = data.map((video) => ({
        category: video.category.S,
        videoId: video.videoId.S,
        description: video.description.S,
        url: video.url.S,
        display_order: video.display_order.N,
        title: video.title.S,
        timestamp: video.timestamp.N,
      }));

      return tranformedData;
    } else {
      console.error("Failed to fetch videos:", response.statusText);
      return null;
    }
  } catch (error) {
    console.error("Error fetching videos:", error);
    return null;
  }
};

export const editVideoData = async (clerkId, videoData) => {
  const requestBody = {
    clerkId,
    ...videoData,
  };
  try {
    const response = await fetch(`${BASE_URL}/videos/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    if (response.ok) {
      return { edited: true };
    } else {
      return { edited: false };
    }
  } catch (error) {
    console.error("Error updating video data: ", error);
    return { edited: false };
  }
};

export const addTeacherProfile = async (teacherData, photo, clerkIdObj) => {
  try {
    const formData = new FormData();
    formData.append(
      "teacher",
      JSON.stringify({
        name: teacherData.name,
        text: teacherData.description,
      })
    );
    formData.append("photo", photo);
    const clerkId = clerkIdObj.clerkId;

    const response = await fetch(`${BASE_URL}/teachers/add`, {
      method: "POST",
      headers: {
        Authorization: clerkId,
      },
      body: formData,
    });
    if (response.ok) {
      return { added: true };
    } else {
      return { added: false };
    }
  } catch (error) {
    console.error("Failed to add teaher: ", error);
    return { added: false };
  }
};

export const updateTeacherProfile = async (teacher, newPhoto, clerkId) => {
  try {
    const formData = new FormData();
    const teacherData = {
      id: teacher.id,
      name: teacher.name,
      text: teacher.text,
      path: teacher.path,
    };
    formData.append("teacher", JSON.stringify(teacherData));

    if (newPhoto) {
      formData.append("file", newPhoto);
    }
    const response = await fetch(`${BASE_URL}/teachers/edit`, {
      method: "POST",
      headers: {
        clerkId: clerkId,
      },
      body: formData,
    });
    if (!response.ok) {
      throw new Error("Failed to update teacher data");
    }
    console.log("Teacher updated successfully!");
    return response;
  } catch (error) {
    console.error("Error updating teacher:", error);
  }
};

export const deleteTeacher = async (teacherId, clerkId) => {
  try {
    const response = await fetch(`${BASE_URL}/teachers/add/`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${clerkId}`,
      },
      body: teacherId,
    });
    if (!response.ok) {
      throw new Error("Failed to delete teacher data");
    }
    return response;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const saveVideoRecommendations = async (updatedVideoData, clerkId) => {
  try {
    const response = await fetch(`${BASE_URL}/videos/recommendations/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${clerkId}`,
      },
      body: JSON.stringify(updatedVideoData),
    });
    return response;
  } catch (error) {
    console.error("Error saving video recommendations data");
    return null;
  }
};

export const saveHomeVideos = async (updatedVideoData, clerkId) => {
  try {
    const response = await fetch(`${BASE_URL}/videos/homepage/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${clerkId}`,
      },
      body: JSON.stringify(updatedVideoData),
    });
    return response;
  } catch (error) {
    console.error("Error saving home videos:", error);
    return null;
  }
};

export const saveLessonStructure = async (editedData, clerkId) => {
  try {
    const response = await fetch(`${BASE_URL}/data/lesson-structure`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${clerkId}`,
      },
      body: JSON.stringify(editedData),
    });
    return response;
  } catch (error) {
    console.error("Error trying to save lessons structure", error);
  }
};

export const deleteUser = async (clerkId, adminId) => {
  try {
    const response = await fetch(`${BASE_URL}/users`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${adminId}`,
      },
      body: JSON.stringify(clerkId),
    });
    return response;
  } catch (error) {
    console.error("error trying to delete user", error);
  }
};

export const updateLessonNominee = async (data, adminId) => {
  try {
    const response = await fetch(`${BASE_URL}/data/lesson-nominee`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${adminId}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response;
  } catch (error) {
    console.error("Error trying to update lesson nominee", error);
  }
};
